import { useListTenants } from '@/api/trafikportalen';
import { CenteredColumn } from '@/components/CenteredColumn';
import { FormSection } from '@/components/FormSection';
import { Loading } from '@/components/Loading';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useContext, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { DocumentHead } from '@/components/core/DocumentHead';
import { ThemeCtx } from '@/contexts/ThemeContext';
import { useFavicon } from '@/hooks/useFavicon';
import { IconExternalLink } from '@/icons';

export const Route = createFileRoute('/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { data: tenants, isLoading } = useListTenants();
  const [, setTenantTheme] = useContext(ThemeCtx);
  useFavicon();

  useEffect(() => {
    setTenantTheme('default');
  }, [setTenantTheme]);

  if (isLoading) {
    return <Loading />;
  }

  if (!tenants || tenants.length === 0) {
    return (
      <>
        <DocumentHead
          titleKey="page.home.noTenants.title"
          descriptionKey="page.home.noTenants.description"
          appendAppName={false}
        />
        <div className="m-auto">
          <FormattedMessage defaultMessage="Ingen portal tillgänglig" />
        </div>
      </>
    );
  }

  return (
    <>
      <DocumentHead
        titleKey="selectPortal.title"
        descriptionKey="selectPortal.description"
        appendAppName={false}
      />
      <CenteredColumn className="h-screen justify-center">
        <FormSection className="m-auto max-w-96">
          <h1>
            <FormattedMessage id="selectPortal.title" />
          </h1>
          <p>
            <FormattedMessage id="selectPortal.description" />
          </p>
          {tenants.map((tenant) => (
            <Link
              key={tenant.id}
              id={tenant.id}
              to="/$tenantId"
              params={{
                tenantId: tenant.id,
              }}
              role="menuitem"
              className="flex items-center rounded-md border border-background-300 p-4 font-medium hover:bg-background-200"
            >
              {tenant.name}
            </Link>
          ))}
          <a
            href="/accessibility"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Tillgänglighetsredogörelse (öppnas i ny flik)"
            className="mx-auto mt-10 inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-medium text-text-950 hover:bg-background-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary-600"
          >
            <FormattedMessage defaultMessage="Tillgänglighetsredogörelse" />
            <IconExternalLink className="ml-2 size-4" aria-hidden="true" />
          </a>
        </FormSection>
      </CenteredColumn>
    </>
  );
}
